
import axios from 'axios'

var getProductDetail = function(bussFlag,pid,callback,errorback){
	axios({
	    method: 'POST',
	    url:'/product/getProductDetail',
		params:{
			bussFlag:bussFlag,
			pid:pid
		},
	}).then((res)=>{
			callback&&callback(res.data);
	}).catch((err)=>{
		errorback&&errorback('网络异常，请稍后重试');
	})
}

var openConsult = function(qqNum,errorback){
				if(qqNum == null || qqNum == ""){
					errorback&&errorback(1);
					return;
				}
				 var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串;
					    var res = 1;
						//欧朋浏览器
						if((userAgent.substring(userAgent.length-6,userAgent.length)=='15C202'||userAgent.substring(userAgent.length-6,userAgent.length)=='15E216')||(userAgent.substring(userAgent.length-6,userAgent.length).indexOf('14G60')>0)||(userAgent.indexOf("OPiOS")>0&&device.iphone())){
							//iphone 7（15C202）  iphone6s(15E216) iphoneSE(OPiOS) iphone5(14G60)不兼容
							res=0;
						}
						if(userAgent.indexOf("Mb2345Browser")>0&&device.iphone()&&(userAgent.indexOf("14A456")>0||userAgent.indexOf("15C114")>0)){
							//iphone 6s 14A456 | iphone715C114 不兼容2345浏览器 
							res=0;
						}
						if(userAgent.indexOf("Quark")>0&&device.iphone()&&(userAgent.indexOf("14A456")>0||userAgent.indexOf("14F89"))){
							//iphone 6s 14A456 | iphone7 不兼容夸克浏览器 
							res=0;
						}
						if(userAgent.indexOf("UCBrowser")>0&&device.iphone()&&userAgent.indexOf("15E216")>0){
							//iphone 6s 不兼容2345浏览器
							res=0;
						}
						if(userAgent.indexOf("searchBrowser")>0&&device.iphone()&&userAgent.indexOf("12B466")>0){
							//iphone 5 不兼容 360安全浏览器
							res=0;
						}
						if(userAgent.indexOf("FxiOS")>0&&device.iphone()&&(userAgent.indexOf("15C202")>0||userAgent.indexOf("15D100")>0||userAgent.indexOf("16A5288q")>0)){
							//火狐浏览器 iphone7 15C202不兼容  iphone 6s 不兼容 火狐浏览器
							res=0;
						}else if(userAgent.indexOf("baiduboxapp") > 0) {
							//二者皆不可以:
							res=0;
						}else if(userAgent.indexOf("baidubrowser") > 0) {
							//二者皆不可以:
							res=0;
						}else if(userAgent.indexOf("MXiOS") > 0 &&device.iphone()) {
							//iphone手机,遨游浏览器:
							if(userAgent.indexOf("MXiOS") > 0 && ((device.iphone()&&(userAgent.indexOf("15C202")>0||userAgent.indexOf("14G60")>0)))){//alert(10);
								//iphone 遨游浏览器 不兼容
								res=1;
							}
							res=0;
						}else if(userAgent.indexOf("MicroMessenger") > 0) {
							//微信,在安卓端会识别到Safari,故单独执行,70606:
							res=1;
						}else if(userAgent.indexOf("iPhone 84") > 0 && userAgent.indexOf("MQQBrowser") > 0) {
							//SE,QQ,71016:
							res=2;
						}else if(userAgent.indexOf("UCBrowser") > 0 || userAgent.indexOf("MQQBrowser") > 0) {
							//70615:
							res=2;
						}else if(userAgent.indexOf("SogouMobileBrowser") > 0) {
							//70615:
							res=1;
						}else if(userAgent.indexOf("QihooBrowser") > 0) {
							res=2;
						}else if(userAgent.indexOf("iPhone") > 0 && userAgent.indexOf("Safari") > 0) {
							res=3;
						}else  if(userAgent.toUpperCase().indexOf("HUAWEI") > 0 && userAgent.indexOf("Safari") > 0) {//0228：华为手机其他浏览器;
							res=3;
						}
						
					    if (device.mobile() || device.ipad()) {
							if(res == 0) {
								window.location.href = "/qqTans?sqq="+qqNum;
							}else if(res == 2) {
								window.location.href = "mqqwpa://im/chat?chat_type=wpa&uin="+qqNum+"&version=1&src_type=web&web_src=5pao.com";
							}else if(res == 3) {
								window.location.href = "mqq://im/chat?chat_type=wpa&uin="+qqNum+"&version=1&src_type=web";
							}else {
								 window.open("//wpa.qq.com/msgrd?v=3&uin=" + qqNum + "&site=qq&menu=yes",'',"width=644,height=544,toolbar=no,scrollbars=no,menubar=no,status=no");
							}
					    } else {
					    	 window.open("//wpa.qq.com/msgrd?v=3&uin=" + qqNum + "&site=qq&menu=yes",'',"width=644,height=544,toolbar=no,scrollbars=no,menubar=no,status=no");
					    }
			}
			
var findCustomer = function(type,callback,errorback){
				axios({
				    method: 'POST',
				    url:'/user/findCustomerQQ',
					params:{
						type:type
					}
				}).then((res)=>{
					if(res.data.code==1000){
						callback&&callback(res.data.obj);
					}
				}).catch((err)=>{
					errorback&&errorback(1);
				}) 
}


var getCustomerInfo = function(callback,errorback){
				axios({
				    method: 'POST',
				    url:'/customer/getCustomerInfo',
				}).then((res)=>{
					if(res.data.code==1000){
						callback&&callback(res.data.obj);
					}
				}).catch((err)=>{
					errorback&&errorback(1);
				}) 
}


//省份选择

var getProv = function(callback,errorback){
	axios({
	    method: 'POST',
	    url:'/address/getUseProv',
	}).then((res)=>{
			if(res.data.code==1000){
				var proName=new Array();
				var proCode=new Array();
				var data = res.data.obj;
				for(var i=0;i<data.length;i++){
					proCode.push(data[i].code);
					proName.push(data[i].name);
				} 
				callback&&callback(proName,proCode);
			}
	}).catch((err)=>{
		errorback&&errorback(1);
	})
}

//城市选择
var getCity = function(code,callback,errorback){
	axios({
	    method: 'POST',
	    url:'/address/getUseCity',
		params:{
			code:code
		}
	}).then((res)=>{
			if(res.data.code==1000){
				var cityName1=new Array();
				var cityCode1=new Array();
				var data = res.data.obj;
				for(var i=0;i<data.length;i++){
					cityName1.push(data[i].name);
					cityCode1.push(data[i].code);
				} 
				callback&&callback(cityCode1,cityName1);
				
			}
	}).catch((err)=>{
		errorback&&errorback(1);
	})
}

/** 立即购买-单个产品 **/


var nowBuyProduct = function(pid,callback,errorback){
	  axios({
	      method: 'POST',
	      url:'/order/orderProduct',
	  	params:{
	  		pid:pid
	  	}
	  }).then((res)=>{
		  	callback&&callback(res.data);
	  }).catch((err)=>{
		    errorback&&errorback("网络异常，请稍后重试");
	  })
} 

export{
	getProductDetail,
	openConsult,
	findCustomer,
	getProv,
	getCity,
	getCustomerInfo,
	nowBuyProduct,
}
